import React, { Suspense } from "react";
import { Box, useTheme, useMediaQuery } from "../../../common/MuiImports";
import { Helmet } from "react-helmet-async";
import { deleteCookieByName } from "../../../../utils/utils";

// Define types for the new props
interface VenueDetails {
  venue_id: string;
  internet_products: any[];
  template: {
    internet_sales_mobile: string;
    internet_sales_desktop: string;
  };
}

interface LandingPageProps {
  data: {
    venue_details: VenueDetails;
    customerStatus?: string;
    inactivePurchasedProducts?: any[];
  };
  isChangePlan?: boolean;
  customerData?: any;
}

const InternetSalesPage: React.FC<LandingPageProps> = ({
  data,
  isChangePlan = false,
  customerData,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [showAllPlans, setShowAllPlans] = React.useState(false);
  
  deleteCookieByName("wpage");
  deleteCookieByName("template");

  const handleSeeAllPlans = () => {
    setShowAllPlans(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Dynamically import the template component based on the template name
  const MobileTemplate = React.lazy(
    () =>
      import(
        `../BroadbandTemplates/${data.venue_details.template.internet_sales_mobile}`
      )
  );
  const DesktopTemplate = React.lazy(
    () =>
      import(
        `../BroadbandTemplates/${data.venue_details.template.internet_sales_desktop}`
      )
  );

  return (
    <>
      <Helmet>
        <title>Boingo Military - Internet Sales</title>
      </Helmet>
      <Box data-test-id="internet-sales-page">
        <Suspense fallback={<div data-test-id="sales-page-loading"></div>}>
          {isMobile ? (
            <Box data-test-id="mobile-template-container">
              <MobileTemplate
                data={{
                  venue_details: data.venue_details,
                  customerStatus: data.customerStatus,
                  inactivePurchasedProducts: data.inactivePurchasedProducts,
                }}
                isChangePlan={isChangePlan}
                customerData={customerData}
                onSeeAllPlans={handleSeeAllPlans}
                showAllPlans={showAllPlans}
              />
            </Box>
          ) : (
            <Box data-test-id="desktop-template-container">
              <DesktopTemplate
                data={{
                  venue_details: data.venue_details,
                  customerStatus: data.customerStatus,
                  inactivePurchasedProducts: data.inactivePurchasedProducts,
                }}
                isChangePlan={isChangePlan}
                customerData={customerData}
                onSeeAllPlans={handleSeeAllPlans}
                showAllPlans={showAllPlans}
              />
            </Box>
          )}
        </Suspense>
      </Box>
    </>
  );
};

export default InternetSalesPage;
